import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'datetimeFormat',
    standalone: false
})

export class DatetimeFormatPipe implements PipeTransform {

    transform(value: Date, formatType: 'date' | 'time' | 'iso', lang: string = 'fr-FR'): string {

        if (!value) {
            return '';
        }

        switch (formatType) {
            case 'date':
                return this.formatDate(value, lang);
            case 'time':
                return this.formatTime(value);
            case 'iso':
                return this.formatDateISO(value, lang);
            default:
                return value.toString();
        }
    }

    private formatTime(date: Date): string {
        return `${this.padZero(date.getHours())}:${this.padZero(date.getMinutes())}`;
    }

    private formatDateISO(date: Date, lang: string): string {
        const options: Intl.DateTimeFormatOptions = {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
        };

        return new Intl.DateTimeFormat(lang, options).format(new Date(date));
    }

    private formatDate(date: Date, lang: string): string {
        const options: Intl.DateTimeFormatOptions = {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        };

        let formattedDate: string = date.toLocaleDateString(lang, options);
        formattedDate = formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);

        return formattedDate;
    }

    private padZero(value: number): string {
        return value < 10 ? `0${value}` : `${value}`;
    }
}